module.exports = __webpack_public_path__ + "img/zl1.13cb35b1.jpg";